import { useLocation } from 'react-router-dom'
import { match } from 'path-to-regexp'
import { Box } from '@mui/material'
import { useTheme } from '@mui/styles'
import SettingsNavTabs from 'components/generic/tabs/SettingsNavTabs'
import { SETTINGS_ADMIN_ROUTES, SETTINGS_PRODUCT_ROUTES } from 'utils/ui/routes'
import { useAppSelector } from 'utils/custom-hooks/useTypedReduxStore'
import { useMemo } from 'react'

const SettingsMenuLayout = () => {
  const theme = useTheme()
  const location = useLocation()
  const { treatments } = useAppSelector(state => state.featureFlags || {})
  // select user role from state
  const permissionsState = useAppSelector(state => state.permissions)
  const userRoles = permissionsState.roles.map(role => role.roleName)

  // Store
  const { inOrgMode } = useAppSelector(state => state.ui)

  const FILTERED_SETTINGS_PRODUCT_ROUTES = SETTINGS_PRODUCT_ROUTES.filter(routeData => {
    const { treatmentKey, title } = routeData
    const treatmentIsOn = !treatmentKey || treatments?.[treatmentKey]?.treatment === 'on'

    if (inOrgMode) {
      return title === 'Dispatch' && treatmentIsOn
    }

    return treatmentIsOn
  })

  const FILTERED_SETTINGS_ADMIN_ROUTES = useMemo(() => {
    return SETTINGS_ADMIN_ROUTES.filter(routeData => {
      const { treatmentKey, title, permittedRoles } = routeData
      // Check if the treatment is enabled
      const treatmentIsOn = !treatmentKey || treatments?.[treatmentKey]?.treatment === 'on'
      // Check if the user has access based on their roles
      const hasAccess = permittedRoles
        ? userRoles.some(role => permittedRoles.includes(role)) // Compare userRoles with permittedRoles
        : true

      if (inOrgMode) {
        return title === 'Users' && treatmentIsOn && hasAccess
      }

      return treatmentIsOn && hasAccess
    })
  }, [inOrgMode, treatments, userRoles])

  const currentAdminTab = SETTINGS_ADMIN_ROUTES.find(tab => {
    const matcher = match(tab.matchPath)
    return matcher(location.pathname)
  })
  const currentProductTab = FILTERED_SETTINGS_PRODUCT_ROUTES.find(tab => {
    const matcher = match(tab.matchPath)
    return matcher(location.pathname)
  })

  return (
    <Box
      sx={{
        borderColor: 'divider',
        position: 'sticky',
        top: 0,
        padding: `${theme.spacing(4)} ${theme.spacing(2)} ${theme.spacing(0)} ${theme.spacing(3)}`,
      }}
    >
      <SettingsNavTabs currentTab={currentAdminTab} tabs={FILTERED_SETTINGS_ADMIN_ROUTES} title="ADMIN" />
      <SettingsNavTabs currentTab={currentProductTab} tabs={FILTERED_SETTINGS_PRODUCT_ROUTES} title="PRODUCT" />
    </Box>
  )
}

export default SettingsMenuLayout
